import { render, staticRenderFns } from "./CampaignSetupPixels.vue?vue&type=template&id=4928a7fd&"
import script from "./CampaignSetupPixels.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixels.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports